import type { IContainerProps } from '~/components/utils/Container';
import { FormSection } from '~/components/atoms/FormSection';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useAppResourcesQuery } from '~/lib/api/modules/AppResources/hooks/useAppResourcesQuery';
import { AssetsSettingsFormAndroidSection } from './AssetsSettingsFormAndroidSection';
import { AssetsSettingsFormIosSection } from './AssetsSettingsFormIosSection';

export type IAssetsSettingsFormProps = IContainerProps & {
  appId: string;
};

export const AssetsSettingsForm: React.FC<IAssetsSettingsFormProps> = (
  props,
) => {
  const { sx, appId } = props;
  const appResourcesQuery = useAppResourcesQuery({ appId });
  const assets = appResourcesQuery.data;

  // TODO:
  // const api = useApi();
  // api.apps.getScreenshots(appId).then((r) => console.log('___', r));

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Suspense
        loading={appResourcesQuery.isLoading}
        error={appResourcesQuery.error}
        first
      >
        {assets ? (
          <ContentBlock.Body first>
            <FormSection>
              <AssetsSettingsFormIosSection appId={appId} assets={assets} />
              <AssetsSettingsFormAndroidSection appId={appId} assets={assets} />
            </FormSection>
          </ContentBlock.Body>
        ) : null}
      </ContentBlock.Suspense>
    </ContentBlock>
  );
};
